import actionTypes from 'constants/actionTypes';

import { TradingOfferType } from 'types/TradingOffer';
import { AddTradingOfferPageProvider } from '../pages/AddTradingOffer/context/AddTradingOfferPageContext';
import AddTradingOfferPage from '../pages/AddTradingOffer';

const EditBuyTradingOfferPageContainer = () => (
  <AddTradingOfferPageProvider
    tradingOfferType={TradingOfferType.BUY}
    actionType={actionTypes.EDIT}
  >
    <AddTradingOfferPage />
  </AddTradingOfferPageProvider>
);

export default EditBuyTradingOfferPageContainer;
